import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { Redirect } from 'react-router-dom'

import CreateAttackHead from 'components/attacks/list/CreateAttackHead'
import SchedulesLayout from 'components/layouts/SchedulesLayout'
import Header, { Heading } from 'components/navigation/Header'
import CreateScenarioHead from 'components/scenarios/CreateScenarioHead'

import AttacksScheduleList from './AttacksScheduleList'
import ScenariosScheduleList from './ScenariosScheduleList'

export default function Schedules({ match }) {
  const tab = match.params.tab

  const TAB_OPTIONS = ['attacks', 'scenarios']

  // If a tab value is entered that doesn't exist; send them to the main schedules page
  if (!TAB_OPTIONS.includes(tab)) {
    return <Redirect to="/schedules" />
  }

  return (
    <Fragment>
      <Helmet title="Scheduled Attacks" />
      <Header>
        <Heading>Scheduled Attacks</Heading>
      </Header>
      <SchedulesLayout>
        <main>
          {tab === 'attacks' && (
            <Fragment>
              <CreateAttackHead activeAttacksPresent={false} />
              <AttacksScheduleList />
            </Fragment>
          )}

          {tab === 'scenarios' && (
            <Fragment>
              <CreateScenarioHead />
              <ScenariosScheduleList />
            </Fragment>
          )}
        </main>
      </SchedulesLayout>
    </Fragment>
  )
}

Schedules.propTypes = {
  match: PropTypes.object.isRequired
}
